import { Store, GetterTree, MutationTree, ActionTree, Module } from "vuex";

import { RootState } from "..";
import { IPublisherState } from "../states/publisher-state";
import { publisherService } from "../../services/publisher.service";
import { IUserPublisherAccess } from "../../models/interfaces/authentication/user-publisher-access.model.interface";
import { IProperty } from "../../models/interfaces/property/property.model.interface";

export const state: IPublisherState = {
  publishers: [],
  assignedProperties: [],
  selectedProperty: JSON.parse(localStorage.getItem("selected-prop") || "null") || null,
  selectedUserPublisherAccess: []
};

export const getters: GetterTree<IPublisherState, RootState> = {
  publishers(state) {
    return state.publishers;
  },
  selectedUserAssignedPublisher(state) {
    return state.publishers.filter((item) => {
      return state.selectedUserPublisherAccess.indexOf(item.publisherId) !== -1;
    });
  },
  selectedUserUnassignedPublishers(state) {
    const matchedPublishers = state.publishers.filter((item) => {
        return state.selectedUserPublisherAccess.indexOf(item.publisherId) === -1;
    });

    const publisherKeyValues = matchedPublishers.map((val) => ({
        value: val.publisherId,
        text: val.name
    }));

    return publisherKeyValues;
  },
  selectedUserPublisherAccess(state) {
    return state.selectedUserPublisherAccess;
  },
  assignedProperties(state) {
    return state.assignedProperties;
  },
  selectedProperty(state) {
    return state.selectedProperty;
  }
};

export const mutations: MutationTree<IPublisherState> = {
  publishers(state, publishers) {
    state.publishers = publishers;
  },
  selectedUserPublisherAccess(state, publishers: number[]) {
    state.selectedUserPublisherAccess = publishers;
  },
  resetUserPublisherAccess(state) {
    state.selectedUserPublisherAccess = [];
  },
  addPublisherAccess(state, publisherId: number) {
    state.selectedUserPublisherAccess.push(publisherId);
  },
  deletePublisherAccess(state, publisherId: number) {
    state.selectedUserPublisherAccess = state.selectedUserPublisherAccess.filter((item) => item !== publisherId);
  },
  assignedProperties(state, properties: IProperty[]) {
    state.assignedProperties = properties;
  },
  selectedProperty(state, property: IProperty) {
    state.selectedProperty = property;

    if (property) {
      localStorage.setItem("selected-prop", JSON.stringify(property));
    } else {
      localStorage.removeItem("selected-prop");
    }
  }
};

export const actions: ActionTree<IPublisherState, RootState> = {
  async retrievePublishers({ state, commit }) {
    return new Promise((resolve, reject) => {
      publisherService.get()
        .then((value) => {
          commit("publishers", value.result);
          resolve(value.success);
        });
    });
  },
  async retrieveSelectedUserPublishers({ state, commit }, userId: number) {
    commit("resetUserPublisherAccess");

    return new Promise((resolve, reject) => {
      publisherService.getUserPublishers(userId)
        .then((value) => {
          if (value.result && value.result.length > 0) {
            commit("selectedUserPublisherAccess", value.result.map((x) => x.publisherId));
          }

          resolve(value.success);
        });
    });
  },
  async addPublisherAccess({ state, commit }, model: IUserPublisherAccess) {
    return new Promise((resolve, reject) => {
      publisherService.addPublisherAccess(model)
        .then((value) => {
          if (value) {
            commit("addPublisherAccess", model.publisherId);
          }

          resolve(value);
        });
    });
  },
  async deletePublisherAccess({ state, commit }, model: IUserPublisherAccess) {
    return new Promise((resolve, reject) => {
      publisherService.deletePublisherAccess(model)
        .then((value) => {
          if (value) {
            commit("deletePublisherAccess", model.publisherId);
          }

          resolve(value);
        });
    });
  },
  async retrieveUserProperties({ state, commit }, userId: number) {
    return new Promise((resolve, reject) => {
      publisherService.getUserProperties(userId)
        .then((value) => {
          if (value.result && value.result.length > 0) {
            commit("assignedProperties", value.result);
            resolve(value.success);
          }
          resolve(false);
        });
    });
  },
  async setSelectedProperty({ state, commit }, property: IProperty) {
    commit("selectedProperty", property);
  }
};

export const publisherModule: Module<IPublisherState, RootState> = {
  state, getters, mutations, actions, namespaced: true
};
